import { useState } from 'react';
import { UserRepository } from '../../../../MedicareProAPI';
import type { oAuthGetTokenSchema } from '../../../../MedicareProAPI/Repositories/User/UserTokenRepository';

type SignUpProperties = {
  onSuccess?: (data: oAuthGetTokenSchema) => void;
  onError?: (err: Error) => void;
};

export function useSignUp(opts: SignUpProperties = {}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const userRepository = new UserRepository();

  async function handleSubmit({
    username: email,
    password,
  }: {
    username: string;
    password: string;
  }) {
    try {
      setSubmitting(true);
      setError(null);
      //const loginResponse = await userTokenRepository.oAuthLogin({ username: email, password: password, client_id: CLIENT_ID });
    } catch (e: any) {
      setError(e.message ?? 'Password reset failed');
      opts.onError?.(e);
    } finally {
      setSubmitting(false);
    }
  }

  return { handleSubmit, submitting, error };
}
